import Image from 'next/image'
import { useTranslation } from 'react-i18next'
import { CircleCheckFill } from '~/core/ui/FillIcons'
import { TypographyText } from '~/core/ui/Text'
import LPContainer from './LPContainer'

const DriveMeasurableSection = () => {
  const { t } = useTranslation()

  const contentBox = [
    t('allFeature:drive:box01'),
    t('allFeature:drive:box02'),
    t('allFeature:drive:box03'),
    t('allFeature:drive:box04'),
    t('allFeature:drive:box05')
  ]

  return (
    <LPContainer className="desktop:my-[140px] my-[64px]">
      <div className="flex tablet:flex-row flex-col space-y-10 tablet:space-y-0 tablet:justify-center tablet:items-center">
        <div>
          <Image
            src="/img/feature/lp/new/talent-intelligence-drive.png"
            width={495}
            height={0}
            alt="talent drive"
          />
        </div>
        <div className="flex-1 tablet:pl-[125px]">
          <TypographyText className="text-[31px] leading-[36px] tablet:text-[37px] tablet:leading-[42px] text-gray-900 font-medium">
            {t('allFeature:drive:title')}
          </TypographyText>
          <div className="mt-10 space-y-6">
            {contentBox.map((box, index) => (
              <div key={index} className="flex space-x-3 items-center">
                <CircleCheckFill className="!fill-green-500" size={20} />
                <span className="text-base font-normal text-gray-900">
                  {box}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </LPContainer>
  )
}

export default DriveMeasurableSection
